export default {
  'constants.yes': '是',
  'constants.no': '否',
};
